<template>
  <validation-observer
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="voluntary-excess"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row
        label="What voluntary excess would you like on this policy?"
        help-text="Select the amount which you will pay if you make a claim. A higher voluntary excess normally reduces your premium. This will be in addition to any compulsory excesses added onto the policy."
        :error="formObserver.validated && !observer.valid"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_voluntary-excess`"
          name="Voluntary Excess"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.voluntaryExcess"
            :data-test="snakeCase(questionFields.voluntaryExcess)"
            :items="voluntaryExcessOptions"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select £ amount', isMobile)"
          />
        </validation-provider>

        <template
          v-if="helpText"
          #helpText
        >
          <div v-html="helpText" />
        </template>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import { sortBy } from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-voluntary-excess',
  extends: QuestionBase,
  data () {
    return {
      fields: ['voluntaryExcess'],
    };
  },
  computed: {
    voluntaryExcessOptions () {
      return sortBy(this.helpers.createOptions({
        source: this.constants.COVER_VOLUNTARY_EXCESS,
        asNumbers: true,
      }), ['value']).reverse();
    },
  },
};
</script>
